import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import dbDrawer from "./component/dbDrawer.vue";
import { getList, getDetail, add, remove } from "@/api/visual/db";
export default {
  mixins: [JeecgListMixin],
  components: {
    dbDrawer: dbDrawer
  },
  data: function data() {
    return {
      autoLoadInit: false,
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '名称',
        align: 'center'
      }, {
        dataIndex: 'driverClassName',
        colName: 'driverClassName',
        title: '驱动类',
        align: 'center'
      }, {
        dataIndex: 'username',
        colName: 'username',
        title: '用户名',
        align: 'center'
      }, {
        dataIndex: 'url',
        colName: 'url',
        title: '连接地址',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      form: {},
      query: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      dicData: [{
        label: 'mysql驱动',
        value: 'com.mysql.jdbc.Driver'
      }, {
        label: 'mysql驱动6.X',
        value: 'com.mysql.cj.jdbc.Driver'
      }, {
        label: 'postgresql驱动',
        value: 'org.postgresql.Driver'
      }],
      data: []
    };
  },
  created: function created() {
    console.log('enter');
    this.onLoad(1);
  },
  methods: {
    handleTableChange: function handleTableChange(pagination, filters, sorter) {
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;

        if (sorter.column && sorter.column.colName) {
          this.isorter.column = sorter.column.colName;
        }

        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination = pagination;
      this.onLoad();
    },
    onToAdd: function onToAdd(row, done) {
      this.$refs.modalForm.add();
    },
    handleEdit: function handleEdit(record, state) {
      var _this = this;

      getDetail(record.id).then(function (res) {
        var data = res.result;

        _this.$refs.modalForm.edit(data, state);
      });
    },
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      remove(id).then(function () {
        _this2.$message.success('删除成功');

        _this2.onLoad();
      });
    },
    onLoad: function onLoad(arg) {
      var _this3 = this;

      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      getList(this.getQueryParams().current, this.getQueryParams().size, this.getQueryParams()).then(function (res) {
        var data = res.result;
        _this3.ipagination.total = data.total;
        data.records.forEach(function (item) {
          var driverClassName = _this3.dicData.filter(function (item1) {
            return item1.value == item.driverClass;
          });

          item['driverClassName'] = item.driverClass;

          if (driverClassName instanceof Array) {
            if (driverClassName.length > 0) {
              item['driverClassName'] = driverClassName[0].label;
            }
          }
        });
        console.log('data.records', data.records);
        _this3.data = data.records;
      });
    }
  }
};